import React from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const InvoicePrint = ({ payment }) => {
  const { invoice_data } = payment;

  if (!invoice_data) return null;

  const handlePrint = () => {
    const data = document.getElementById("invoice-container").innerHTML;
    const pri = document.getElementById("ifmcontentstoprint").contentWindow;

    // 1️⃣ Obtener todos los estilos del documento actual
    let styles = "";
    document.querySelectorAll("link[rel='stylesheet'], style").forEach((style) => {
      styles += style.outerHTML;
    });


    pri.document.open();
    pri.document.write(`
    <html>
      <head>
        ${styles}
      </head>
      <body>
        ${data}
      </body>
    </html>
  `); pri.document.close();

    setTimeout(() => {
      pri.focus();
      pri.print();
    }, 900);
  };

  return (
    <div className="invoice-container" id='invoice-container'>
      <div className="no-print mb-4">
        <button
          onClick={handlePrint}
          data-testid="print-button"
          className="px-6 py-2 rounded-lg font-semibold text-white"
          style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
        >
          Imprimir Factura
        </button>
      </div>

      <div className="print-content bg-white p-8 max-w-4xl mx-auto shadow-lg">
        {/* Header */}
        <div className="border-b-2 border-gray-300 pb-6 mb-6">
          <h1 className="text-4xl font-bold mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif', color: '#667eea' }}>
            FACTURA
          </h1>
          <div className="flex justify-between mt-4">
            <div>
              <p className="text-lg font-semibold">Billing Platform</p>
              <p className="text-sm text-gray-600">Gestión profesional de suscripciones</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold">Factura: {invoice_data.invoice_number}</p>
              <p className="text-sm text-gray-600">
                Fecha: {new Date(invoice_data.date).toLocaleDateString('es-ES')}
              </p>
            </div>
          </div>
        </div>

        {/* Billing Info */}
        <div className="mb-6">
          <h3 className="font-semibold text-lg mb-3" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Información de Facturación
          </h3>
          <div className="bg-gray-50 p-4 rounded">
            <p><strong>Tipo:</strong> {invoice_data.billing_info.tipo_comprobante}</p>
            <p><strong>RNC:</strong> {invoice_data.billing_info.rnc}</p>
            <p><strong>Nombre:</strong> {invoice_data.billing_info.nombre}</p>
            <p><strong>Dirección:</strong> {invoice_data.billing_info.direccion}</p>
            <p><strong>Teléfono:</strong> {invoice_data.billing_info.telefono}</p>
          </div>
        </div>

        {/* Items Table */}
        <div className="mb-6">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 text-left">Descripción</th>
                <th className="border border-gray-300 p-3 text-center">Duración</th>
                <th className="border border-gray-300 p-3 text-right">Precio Unit.</th>
                <th className="border border-gray-300 p-3 text-right">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {invoice_data.items.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 p-3">{item.product_name}</td>
                  <td className="border border-gray-300 p-3 text-center">{item.duration_months} meses</td>
                  <td className="border border-gray-300 p-3 text-right">${item.unit_price}</td>
                  <td className="border border-gray-300 p-3 text-right">${item.subtotal}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Totals */}
        <div className="flex justify-end mb-6">
          <div className="w-64">
            <div className="flex justify-between py-2 border-b">
              <span>Subtotal:</span>
              <span>${invoice_data.subtotal}</span>
            </div>
            {invoice_data.discount > 0 && (
              <div className="flex justify-between py-2 border-b text-green-600">
                <span>Descuento:</span>
                <span>-${invoice_data.discount}</span>
              </div>
            )}
            <div className="flex justify-between py-3 font-bold text-lg" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              <span>TOTAL:</span>
              <span>${invoice_data.total}</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t-2 border-gray-300 pt-4 mt-8 text-center text-sm text-gray-600">
          <p>Gracias por su compra</p>
          <p>Para cualquier consulta, contáctenos en soporte@billingplatform.com</p>
        </div>
      </div>

      <style jsx>{`
        @media print {
          .no-print {
            display: none;
          }
          .print-content {
            box-shadow: none;
          }
          body {
            print-color-adjust: exact;
            -webkit-print-color-adjust: exact;
          }
        }
      `}</style>
    </div>
  );
};

export default InvoicePrint;